export default __webpack_public_path__ + "static/media/Sriracha-Regular.fed291b3.ttf";